import request from '../utils/request'

/**
 * 任务管理API
 */

// 创建任务
export function createTask(data) {
  return request({
    url: '/task',
    method: 'post',
    data
  })
}

// 获取任务列表（按项目分页）
export function getTaskListPaged(params) {
  return request({
    url: `/task/project/${params.project_id}`,
    method: 'get',
    params: {
      page: params.page,
      page_size: params.page_size,
      status: params.status
    }
  })
}

// 获取用户所有项目的任务列表（后台统一处理）
export function getMyAllTasks(params) {
  return request({
    url: '/task/my/all',
    method: 'get',
    params: {
      page: params.page,
      page_size: params.page_size,
      status: params.status,
      assignee_id: params.assignee_id,
      priority: params.priority,
      keywords: params.keywords
    }
  })
}

// 获取任务详情
export function getTaskDetail(id) {
  return request({
    url: `/task/${id}`,
    method: 'get'
  })
}

// 更新任务
export function updateTask(id, data) {
  return request({
    url: `/task/${id}`,
    method: 'put',
    data
  })
}

// 删除任务
export function deleteTask(id) {
  return request({
    url: `/task/${id}`,
    method: 'delete'
  })
}

// 更新任务状态
export function updateTaskStatus(id, data) {
  return request({
    url: `/task/${id}/status`,
    method: 'put',
    data
  })
}

// 获取用户待办任务列表
export function getUserTodoTasks() {
  return request({
    url: '/task/user/todo',
    method: 'get'
  })
}

// 获取用户最近更新的任务列表
export function getUserRecentTasks(limit = 10) {
  return request({
    url: '/task/user/recent',
    method: 'get',
    params: { limit }
  })
}

// 检查根任务是否全部完成
export function checkRootTaskCompletion(id, autoUpdate = false) {
  return request({
    url: `/task/root/${id}/check-completion`,
    method: 'get',
    params: {
      auto_update: autoUpdate
    }
  })
}

// 检查项目中所有根任务是否全部完成
export function checkProjectAllRootTasks(projectId) {
  return request({
    url: `/task/project/${projectId}/check-all-completed`,
    method: 'get'
  })
}

// 自动更新项目中满足条件的根任务状态
export function autoUpdateProjectRootTasks(projectId) {
  return request({
    url: `/task/project/${projectId}/auto-update-completed`,
    method: 'post'
  })
}

// 处理项目任务流转
export function processProjectTaskFlow(projectId) {
  return request({
    url: `/task/project/${projectId}/process-flow`,
    method: 'post'
  })
}

// 处理根任务流转
export function processRootTaskFlow(rootTaskId) {
  return request({
    url: `/task/root/${rootTaskId}/process-flow`,
    method: 'post'
  })
}

// 处理任务执行反馈
export function processExecutionFeedback(id, data) {
  return request({
    url: `/task/${id}/feedback/execution`,
    method: 'post',
    data
  })
}

// 处理任务协调反馈
export function processCoordinationFeedback(id, data) {
  return request({
    url: `/task/${id}/feedback/coordination`,
    method: 'post',
    data
  })
}

// 获取任务反馈状态
export function getTaskFeedbackStatus(id) {
  return request({
    url: `/task/${id}/feedback/status`,
    method: 'get'
  })
}

// 获取子任务列表
export function getSubTasks(id) {
  return request({
    url: `/task/${id}/subtasks`,
    method: 'get'
  })
}

// 获取根任务下所有子任务
export function getRootTaskChildren(rootTaskId) {
  return request({
    url: `/task/root/${rootTaskId}/children`,
    method: 'get'
  })
}

// 获取任务依赖
export function getTaskDependencies(id) {
  return request({
    url: `/task/${id}/dependencies`,
    method: 'get'
  })
}

// 设置任务依赖
export function setTaskDependencies(id, data) {
  return request({
    url: `/task/${id}/dependencies`,
    method: 'put',
    data
  })
}

// 获取任务历史
export function getTaskHistory(id) {
  return request({
    url: `/task/${id}/history`,
    method: 'get'
  })
}

// 获取关联会话
export function getRelatedSessions(id) {
  return request({
    url: `/task/${id}/sessions`,
    method: 'get'
  })
}

// 获取项目根任务列表
export function getProjectRootTasks(projectId) {
  return request({
    url: `/task/project/${projectId}/root-tasks`,
    method: 'get'
  })
}

// 获取项目所有任务
export function getProjectAllTasks(projectId) {
  return request({
    url: `/task/project/${projectId}/all-tasks`,
    method: 'get'
  })
}

// 检查项目所有依赖
export function checkProjectDependencies(projectId) {
  return request({
    url: `/task/project/${projectId}/dependencies`,
    method: 'get'
  })
}

// 构建任务层级结构
export function getTaskHierarchy(rootTaskId) {
  return request({
    url: `/task/root/${rootTaskId}/hierarchy`,
    method: 'get'
  })
}

// 验证层级一致性
export function verifyHierarchy(rootTaskId) {
  return request({
    url: `/task/root/${rootTaskId}/verify`,
    method: 'get'
  })
}

// 获取等待且依赖未满足的任务
export function getWaitingTasksWithUnmetDeps(rootTaskId) {
  return request({
    url: `/task/root/${rootTaskId}/waiting-dependencies`,
    method: 'get'
  })
}

// 检查并更新依赖状态
export function checkAndUpdateDependencies(rootTaskId) {
  return request({
    url: `/task/root/${rootTaskId}/check-dependencies`,
    method: 'post'
  })
}

export default {
  createTask,
  getTaskListPaged,
  getTaskDetail,
  updateTask,
  deleteTask,
  updateTaskStatus,
  getUserTodoTasks,
  getUserRecentTasks,
  checkRootTaskCompletion,
  checkProjectAllRootTasks,
  autoUpdateProjectRootTasks,
  processProjectTaskFlow,
  processRootTaskFlow,
  processExecutionFeedback,
  processCoordinationFeedback,
  getTaskFeedbackStatus,
  getSubTasks,
  getRootTaskChildren,
  getTaskDependencies,
  setTaskDependencies,
  getTaskHistory,
  getRelatedSessions,
  getProjectRootTasks,
  getProjectAllTasks,
  checkProjectDependencies,
  getTaskHierarchy,
  verifyHierarchy,
  getWaitingTasksWithUnmetDeps,
  checkAndUpdateDependencies
}
